import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import _throttle from 'lodash.throttle';
export var useViewportHeight = function useViewportHeight(isIOSSafari) {
  var _useState = useState(window.innerHeight),
      _useState2 = _slicedToArray(_useState, 2),
      vh = _useState2[0],
      setVh = _useState2[1];

  useEffect(function () {
    var throttledScrollEvent = _throttle(function () {
      setVh(window.innerHeight);
    });

    if (!isIOSSafari) return;
    window.addEventListener('scroll', throttledScrollEvent);
    return function () {
      window.removeEventListener('scroll', throttledScrollEvent);
    };
  }, [isIOSSafari, setVh]);
  return {
    vh: vh
  };
};